import * as actionTypes from "./actionTypes";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getLocalizedString, getErrorStringFromServerError } from "@icarius-localization/strings";
import {
  getGeoQueryDefinitionAPI,
  createGeoQueryDefinitionAPI,
  modifyGeoQueryDefinitionAPI,
  deleteGeoQueryDefinitionAPI,
  duplicateGeoQueryDefinitionAPI,
} from "@icarius-connection/api";

const errorHandler = (e, dispatch) => {
  let errorString = "";
  switch (e.response?.data?.status) {
    case "INVALID_DATA":
    case "VALIDATION_ERROR":
      errorString = getLocalizedString("validationError");
      break;
    case "DUPLICATED_DATA":
      errorString = getLocalizedString("cannotHaveMoreThanOneGeoanalysisQueryWithSameCodeOrName");
      break;
    default:
      errorString = getErrorStringFromServerError(e);
      break;
  }
  dispatch(openSnackbarAction({ msg: errorString, severity: "error" }));
}

export const getGeoQueryDefinitionAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET_ROWS });
  try {
    let response = await getGeoQueryDefinitionAPI();
    
    let rows = response.data && response.data.data;
    let dataTypes = response.data && response.data.dataTypes;
    let roleTypes = response.data && response.data.rolTypes;
    let activeTypes = response.data && response.data.activeTypes;
    let markTypes = response.data && response.data.markTypes;
    let dateFormat = response.data && response.data.dateFormat;

    dispatch({
      type: actionTypes.GET_ROWS_FULFILLED,
      payload: { rows, dataTypes, roleTypes, activeTypes, markTypes, dateFormat }
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_ROWS_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};

export const createGeoQueryDefinitionAction = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.CREATE });
  try {
    let response = await createGeoQueryDefinitionAPI(data);

    let rows = response.data && response.data.data;
    let dataTypes = response.data && response.data.dataTypes;
    let roleTypes = response.data && response.data.rolTypes;
    let activeTypes = response.data && response.data.activeTypes;
    let markTypes = response.data && response.data.markTypes;
    let dateFormat = response.data && response.data.dateFormat;

    dispatch({
      type: actionTypes.CREATE_FULFILLED,
      payload: { rows, dataTypes, roleTypes, activeTypes, markTypes, dateFormat }
    });
    dispatch(openSnackbarAction({ msg: getLocalizedString("geoanalysisQueryCreatedSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.CREATE_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};

export const modifyGeoQueryDefinitionAction = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.MODIFY });
  try {
    let response = await modifyGeoQueryDefinitionAPI(data);

    let rows = response.data && response.data.data;
    let dataTypes = response.data && response.data.dataTypes;
    let roleTypes = response.data && response.data.rolTypes;
    let activeTypes = response.data && response.data.activeTypes;
    let markTypes = response.data && response.data.markTypes;
    let dateFormat = response.data && response.data.dateFormat;

    dispatch({
      type: actionTypes.MODIFY_FULFILLED,
      payload: { rows, dataTypes, roleTypes, activeTypes, markTypes, dateFormat }
    });
    dispatch(openSnackbarAction({ msg: getLocalizedString("geoanalysisQueryDefinitionModifiedSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.MODIFY_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};

export const deleteGeoQueryDefinitionAction = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.DELETE });
  try {
    let response = await deleteGeoQueryDefinitionAPI(data);

    let rows = response.data && response.data.data;
    let dataTypes = response.data && response.data.dataTypes;
    let roleTypes = response.data && response.data.rolTypes;
    let activeTypes = response.data && response.data.activeTypes;
    let markTypes = response.data && response.data.markTypes;
    let dateFormat = response.data && response.data.dateFormat;

    dispatch({
      type: actionTypes.DELETE_FULFILLED,
      payload: { rows, dataTypes, roleTypes, activeTypes, markTypes, dateFormat }
    });
    dispatch(openSnackbarAction({ msg: getLocalizedString("geoanalysisQueryDefinitionDeletedSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {    
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
    errorHandler(e, dispatch);
  }
};

export const duplicateGeoQueryDefinitionAction = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.DUPLICATE });
  try {
    let response = await duplicateGeoQueryDefinitionAPI(data);

    let rows = response.data && response.data.data;
    let dataTypes = response.data && response.data.dataTypes;
    let roleTypes = response.data && response.data.rolTypes;
    let activeTypes = response.data && response.data.activeTypes;
    let markTypes = response.data && response.data.markTypes;
    let dateFormat = response.data && response.data.dateFormat;

    dispatch({
      type: actionTypes.DUPLICATE_FULFILLED,
      payload: { rows, dataTypes, roleTypes, activeTypes, markTypes, dateFormat }
    });
    dispatch(openSnackbarAction({ msg: getLocalizedString("geoanalysisQueryDuplicatedSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.DUPLICATE_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};

